

/**
 *
 * @class LocomotiveDataHandle
 *
 * The specific FAV over in BigQuery.  Looks like:
 *
 *   {
 *    "ID":                           "67ae7045-b7a0-4716-81b8-6bce683a899c",
 *    "name":                         "POC_DEC_2022",
 *    "forecast_analysis_version_id": 1000,
 *    "description":                  "",
 *    "timestamp_creation":           {},
 *    "created_by":                   "cn\/163088",
 *    "dataset_name":                 "z_fav_POC_DEC_2022_99"
 *  }
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2022
 *
 */
export class FAVRecord {

  public ID:                           string  = '';
  public name:                         string  = '';
  public forecast_analysis_version_id: number  = 0;
  public timestamp_creation:           any     = {};
  public created_by:                   string  = '';
  public dataset_name:                 string  = '';

  /** standard constructor */
  public constructor(init?: Partial<FAVRecord>) {

    Object.assign(this, init);
  }

}
